import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      color: '#9EA3B0',
      fontSize: 20,
      fontWeight: 'bold',
      margin: theme.spacing(0.5, 0),
    },
    subtitle: {
      fontSize: 16,
      textAlign: 'center',
      color: '#9EA3B0',
    },
  }),
);

export default useStyles;
